import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './lib/AuthContext'
import * as Sentry from '@sentry/react'
import './index.css'
import './styles/theme-flare.css'
import App from './App.jsx'
import db from './lib/db'
import { isDevMode } from './lib/devMode'
import { applyMode, getActiveUserId, getStoredMode, purgeLegacyKeyIfOrphaned } from './lib/displayMode'

if (isDevMode) {
  import('./lib/devTools').then(m => m.installDevTools())
}

// Apply persisted display mode for the *currently signed-in user* before
// the first paint, so a high-contrast user doesn't see a flash of dark
// on every reload AND the previous account's preference doesn't leak to
// whoever's signed in now. AuthContext re-applies on auth state change.
purgeLegacyKeyIfOrphaned()
applyMode(getStoredMode(getActiveUserId()))

db.init()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('SW registered:', reg.scope))
      .catch(err => console.log('SW registration failed:', err))
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Our team has been notified.</p>}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)